import { TextField, styled } from '@mui/material';
import { chatSlimScrollbarStyles } from '../../utils/styles';

interface IStyledTextFieldProps {
  error?: boolean;
  bordercolor?: string;
  padding?: string;
  inputPadding?: string;
}

const StyledTextField = styled(TextField)<IStyledTextFieldProps>(
  ({
    theme,
    error = false,
    bordercolor = '#7CAEBE',
    padding = '',
    inputPadding = '16.5px 14px',
  }) => ({
    '& .MuiInputBase-root': {
      backgroundColor: error ? '#E161621A' : '#FFFFFF',
      borderRadius: '10px',
      padding,
    },
    '& .MuiOutlinedInput-input': {
      padding: inputPadding,
    },

    '& .MuiInputBase-input': {
      ...theme.typography.bodyRegular,
      color: error ? '#E16162' : 'inherit',

      ...chatSlimScrollbarStyles,
      '&:-webkit-autofill': {
        '-webkit-text-fill-color': theme.palette.primary.dark,
        '-webkit-box-shadow': `0 0 0 1000px ${theme.palette.primary.light} inset`,
      },
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: `1px solid var(--Accent-Moonstone-Blue, ${bordercolor})`,
      },
      '&:hover fieldset': {
        border: `1px solid var(--Accent-Moonstone-Blue, ${bordercolor})`,
      },
      '&.Mui-focused fieldset': {
        border: `1px solid var(--Accent-Moonstone-Blue, ${bordercolor})`,
      },
    },
    '& ::placeholder': {
      opacity: 0.2,
    },
  })
);

export default StyledTextField;
